module.exports = __webpack_public_path__ + "static/media/growth.ebfd3d33.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/growth.gif
// module id = 54
// module chunks = 0